export const strictType = <T>(value: T): T => value;
